import React, { createContext, useContext } from 'react'

interface WhiteboardIdContextType {
  selectedWhiteboardId: string | null
}

const WhiteboardIdContext = createContext<WhiteboardIdContextType | undefined>(
  undefined
)

export const WhiteboardIdProvider: React.FC<{
  selectedWhiteboardId: string | null
  children: React.ReactNode
}> = ({ selectedWhiteboardId, children }) => {
  return (
    <WhiteboardIdContext.Provider value={{ selectedWhiteboardId }}>
      {children}
    </WhiteboardIdContext.Provider>
  )
}

export const useWhiteboardId = () => {
  const context = useContext(WhiteboardIdContext)
  // Return null if not in SystemView context
  return context?.selectedWhiteboardId ?? null
}
